/* shared scroll lock: overlays freeze the page without losing position.
   slNudgeLater (seve-light-nav) makes iOS Safari re-read its status-bar colour
   once the overlay is in place, and again once it has finished sliding in. */
window.slLock = (function () {
  var y = 0, n = 0;
  return {
    lock: function () {
      if (++n > 1) return;
      y = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = (-y) + 'px';
      document.body.style.width = '100%';
      if (window.slNudgeLater) window.slNudgeLater();
    },
    unlock: function () {
      if (n > 0) n--;
      if (n > 0) return;
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, y);
      if (window.slNudgeLater) window.slNudgeLater();
    }
  };
})();

/* =========================================================================
   SÈVE — LIGHT THEME MOTION
   Scroll reveals, parallax, count-ups, hover swaps, marquees, progress.

   Two rules everything here obeys:
   1. Classes are added BY SCRIPT, never in markup. If this file fails, every
      element is simply visible. Nothing is ever hidden by CSS waiting on JS.
   2. prefers-reduced-motion short-circuits the lot.
   ========================================================================= */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var root = document.querySelector('.seve-light');
    if (!root || root.dataset.slMotion) return;
    root.dataset.slMotion = '1';
    if (REDUCED || !('IntersectionObserver' in window)) return;

    heroLoad(root);
    autoRail(root);
    autoDeck(root);
    railNudge(root);
    reveals(root);
    parallax(root);
    hoverSwaps(root);
    tiltCards(root);
  }

  /* ---------------------------------------------------- hero word stagger
     Splits the hero headline into word spans and raises them one by one.
     Runs only once per load; markup untouched if JS is absent. */
  /* ------------------------------------------------- above-the-fold load-in
     One short fade/rise for first-viewport heads, subs and CTAs. Runs on init
     (DOMContentLoaded), total sequence <= 600ms, with its own failsafe. The
     classes are added here, never in markup, so no-JS pages are fully visible. */
  function heroLoad(root) {
    var sel = '.slh-hero__h, .slc-hero__h, .sll-vid__h, .slh-hero__sub, .slc-hero__sub, ' +
              '.slh-hero__cta, .slc-hero__cta, .slh-hero__rate, .slp-buy__title, .slp-pricerow';
    var list = [].filter.call(root.querySelectorAll(sel), function (el) {
      return el.getBoundingClientRect().top < window.innerHeight;
    });
    if (!list.length) return;
    /* headline leads; subhead, CTAs and the rating row follow together */
    var slots = { 'slh-hero__h': 0, 'slc-hero__h': 0, 'sll-vid__h': 0, 'slp-buy__title': 0 };
    list.forEach(function (el, i) {
      el.classList.add('sl-la');
      var lead = Object.keys(slots).some(function (c) { return el.classList.contains(c); });
      el.style.transitionDelay = lead ? '0ms' : Math.min(i, 3) * 80 + 120 + 'ms';
    });
    var go = function () { list.forEach(function (el) { el.classList.add('sl-la-in'); }); };
    requestAnimationFrame(function () { requestAnimationFrame(go); });
    setTimeout(go, 700);
  }

  /* --------------------------------------------------- auto-scrolling photo rail
     "Out on the road" carousels on its own. It is a marquee, not a control, so
     every way a person can touch it wins over the animation: hover, focus,
     drag, wheel and the arrow buttons all stop it, and it only runs while it is
     actually on screen and the tab is visible.

     The items are duplicated once so the wrap is invisible. Snap and smooth
     scrolling are switched off per-rail here rather than in the stylesheet,
     because both fight a per-frame scrollLeft and .sl-rail still serves rails
     that are not animated. Under prefers-reduced-motion this never runs at all
     (init returns before it), which leaves the rail as a normal manual rail. */
  function autoRail(root) {
    [].forEach.call(root.querySelectorAll('.slh-rail'), function (rail) {
      if (rail.dataset.slAuto) return;
      var items = [].slice.call(rail.children);
      if (items.length < 3) return;
      rail.dataset.slAuto = '1';

      /* clones are decorative: out of the tab order and hidden from AT */
      items.forEach(function (it) {
        var c = it.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        [].forEach.call(c.querySelectorAll('a,button,input,[tabindex]'), function (el) { el.tabIndex = -1; });
        rail.appendChild(c);
      });

      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';

      var loop = 0;
      function measure() {
        var firstClone = rail.children[items.length];
        loop = firstClone ? firstClone.offsetLeft - rail.children[0].offsetLeft : 0;
      }
      measure();
      window.addEventListener('resize', measure, { passive: true });
      /* the images land after first layout, so the width is only real then */
      [].forEach.call(rail.querySelectorAll('img'), function (im) {
        if (!im.complete) im.addEventListener('load', measure, { once: true });
      });

      var SPEED = 0.5;       /* px per frame, roughly 30px a second */
      var hover = false, hold = 0, onScreen = false;
      /* The position is kept here as a float and assigned absolutely. WebKit
         reports scrollLeft as a rounded integer, so "scrollLeft += 0.5" reads
         back the same number every frame and the rail never moves. */
      var pos = rail.scrollLeft;

      function frame() {
        requestAnimationFrame(frame);
        /* On the frame the pause runs out, pick up wherever the person left
           the rail. Syncing only at pointerdown would snap it back to where
           their drag started. */
        if (hold > 0) { hold--; if (hold === 0) pos = rail.scrollLeft; }
        if (hover || hold > 0 || !onScreen || !loop || document.hidden) return;
        pos += SPEED;
        if (pos >= loop) pos -= loop;
        rail.scrollLeft = pos;
      }

      /* a human moved it, so pick the animation back up from where they left it */
      function nudgeOff(frames) { hold = Math.max(hold, frames); pos = rail.scrollLeft; }
      /* Hover-pause is for mice only. On a touch screen pointerenter fires on
         tap and no pointerleave ever follows, so a single tap would freeze the
         rail for good. Touch is covered by the timed pause below. */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        rail.addEventListener('pointerenter', function () { hover = true; });
        rail.addEventListener('pointerleave', function () { hover = false; });
      }
      rail.addEventListener('focusin', function () { hover = true; });
      rail.addEventListener('focusout', function () { hover = false; });
      /* after a deliberate touch, stay out of the way for about six seconds */
      rail.addEventListener('pointerdown', function () { nudgeOff(360); }, { passive: true });
      rail.addEventListener('touchstart', function () { nudgeOff(360); }, { passive: true });
      rail.addEventListener('wheel', function () { nudgeOff(360); }, { passive: true });
      [].forEach.call(document.querySelectorAll('[data-rail]'), function (b) {
        b.addEventListener('click', function () { nudgeOff(360); });
      });

      new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScreen = e.isIntersecting; });
      }, { threshold: 0 }).observe(rail);

      requestAnimationFrame(frame);
    });
  }

  /* ------------------------------------------------------- one-at-a-time deck
     A snap carousel that advances on its own: the review deck shows a single
     card, swipes on touch, and steps every few seconds. Same courtesy rules as
     the photo rail, a person always wins over the animation. */
  function autoDeck(root) {
    [].forEach.call(root.querySelectorAll('[data-sl-deck]'), function (deck) {
      if (deck.dataset.slDeck === 'on') return;
      var cards = [].slice.call(deck.children);
      if (cards.length < 2) return;
      deck.dataset.slDeck = 'on';

      var STEP = 300;                /* frames between advances, about 5s */
      var tick = 0, hold = 0, hover = false, onScreen = false;

      /* which card is nearest the middle right now, measured rather than
         remembered, so a swipe or an arrow never puts the count out of step */
      function current() {
        var dr = deck.getBoundingClientRect(), mid = dr.left + dr.width / 2;
        var best = 0, bd = Infinity;
        cards.forEach(function (c, k) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bd) { bd = d; best = k; }
        });
        return best;
      }

      function go(k, smooth) {
        var c = cards[(k + cards.length) % cards.length];
        if (c.scrollIntoView) c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: smooth ? 'smooth' : 'auto' });
      }

      function frame() {
        requestAnimationFrame(frame);
        if (hold > 0) hold--;
        if (hover || hold > 0 || !onScreen || document.hidden) { tick = 0; return; }
        if (++tick < STEP) return;
        tick = 0;
        var n = current();
        /* the wrap back to the first card jumps rather than sliding past 40 */
        go(n + 1, n + 1 < cards.length);
      }

      function pause(frames) { hold = Math.max(hold, frames); tick = 0; }
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        deck.addEventListener('pointerenter', function () { hover = true; });
        deck.addEventListener('pointerleave', function () { hover = false; });
      }
      deck.addEventListener('focusin', function () { hover = true; });
      deck.addEventListener('focusout', function () { hover = false; });
      deck.addEventListener('pointerdown', function () { pause(420); }, { passive: true });
      deck.addEventListener('touchstart', function () { pause(420); }, { passive: true });
      deck.addEventListener('wheel', function () { pause(420); }, { passive: true });

      [].forEach.call(document.querySelectorAll('[data-deck]'), function (b) {
        b.addEventListener('click', function () {
          pause(420);
          go(current() + parseInt(b.getAttribute('data-deck'), 10), true);
        });
      });

      new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScreen = e.isIntersecting; });
      }, { threshold: 0 }).observe(deck);

      requestAnimationFrame(frame);
    });
  }

  function railNudge(root) {
    var rail = root.querySelector('.slh-rail');
    if (!rail || !('IntersectionObserver' in window)) return;
    if (rail.dataset.slAuto) return;   /* it is already moving on its own */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        setTimeout(function () { rail.classList.add('is-nudge'); }, 350);
      });
    }, { threshold: 0.4 });
    io.observe(rail);
  }

  /* ---------------------------------------------------------------- reveals
     Direction varies by element so a page does not feel like one long
     conveyor belt: media scales in, side-by-side blocks come from the edge,
     everything else rises. */
  function reveals(root) {
    var GROUPS = [
      /* headings and prose rise */
      { sel: '.sl-head, .slc-rt__h, .slc-rt__b, .slc-feat__body, .slh-story__body, ' +
             '.slc-brick__inner, .slc-step, .slc-quote, .slc-form__side, .slc-acc__side, ' +
             '.slh-ben__lead, .slh-spec__note, .slp-buy__head, .slp-buy__tag, .slp-inside > div, ' +
             '.slp-nfp, .slp-pq, .sll-label',
        dir: 'up' },
      /* container-level reveals only: grids rise as one unit */
      { sel: '.slh-range, .slcol__grid, .slh-voices, .sll-quotes, .slp-more__row, ' +
             '.slq__plan',
        dir: 'up' },
      /* media scales in from slightly under (never the PDP hero gallery) */
      { sel: '.slc-feat__media, .slh-story__media, .slc-img, .slc-banner, .slc-mt__media, ' +
             '.slc-brick__media, .slh-ben, .slp-how__media, .slcol__banner',
        dir: 'scale' },
      { sel: '.slc-mt--flip .slc-mt__body, .slc-brick--flip .slc-brick__inner', dir: 'right' },
      { sel: '.slc-mt__body, .slc-form__main, .slp-buy', dir: 'right' },
      { sel: '.slf__col, .sl-marquee', dir: 'up' }
    ];

    var all = [];
    GROUPS.forEach(function (g) {
      root.querySelectorAll(g.sel).forEach(function (el) {
        if (el.dataset.slR) return;
        el.dataset.slR = '1';
        el.classList.add('sl-r', 'sl-r--' + g.dir);
        all.push(el);
      });
    });
    if (!all.length) return;

    /* stagger siblings so a row lands as a row */
    var counts = new Map();
    all.forEach(function (el) {
      var k = el.parentElement;
      var i = counts.get(k) || 0;
      counts.set(k, i + 1);
      el.style.transitionDelay = Math.min(i, 6) * 65 + 'ms';
    });

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    all.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
        el.style.transitionDelay = '0ms';
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });

    /* Safety net. An End-key jump or a scrollbar drag skips whole sections, the
       observer never fires for them, and scrolling back up would show blank
       content. So reveal everything from the top of the document down to the
       bottom of the current viewport — not just what is on screen right now.
       A hidden element is a far worse failure than a missed animation. */
    var sweep = function () {
      var vh = window.innerHeight;
      all.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < vh) {
          el.style.transitionDelay = '0ms';
          el.classList.add('is-in');
        }
      });
    };
    window.addEventListener('scroll', function () { setTimeout(sweep, 120); }, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    window.addEventListener('load', sweep);
    setTimeout(sweep, 1500);
    /* hard failsafe: whatever the observers did or did not do, everything is
       visible 2.5s after init. A missed animation beats hidden content. */
    setTimeout(function () {
      all.forEach(function (el) {
        if (!el.classList.contains('is-in')) {
          el.style.transitionDelay = '0ms';
          el.classList.add('is-in');
        }
      });
    }, 2500);
  }

  /* --------------------------------------------------------------- count-up
     Stat numerals tick up when they arrive. Any non-numeric part of the label
     (units, decimals, the g in 26g) is preserved exactly. */
  /* --------------------------------------------------------------- parallax
     Full-bleed media drifts slower than the page. Transform only, driven off
     a single rAF-throttled scroll listener. */
  function parallax(root) {
    var items = [].slice.call(root.querySelectorAll('.slh-hero__bg, .slc-hero__bg, .slh-ben__bg, .slc-brick__media img'));
    if (!items.length) return;
    items.forEach(function (el) { el.classList.add('sl-px'); });
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var host = el.closest('.slh-hero, .slc-hero, .slh-ben, .slc-brick__media') || el.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;   /* -1 .. 1 */
        el.style.transform = 'translate3d(0,' + (progress * -26).toFixed(2) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------ hover swaps
     Product cards cross-fade to their second image on hover. The alt image is
     injected here rather than in Liquid so cards without one are untouched. */
  function hoverSwaps(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-alt-src]').forEach(function (wrap) {
      if (wrap.dataset.slSwap) return;
      wrap.dataset.slSwap = '1';
      var src = wrap.getAttribute('data-alt-src');
      if (!src) return;
      var img = new Image();
      wrap.addEventListener("pointerenter", function () { img.src = src; }, { once: true });
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'sl-swap';
      wrap.appendChild(img);
      wrap.classList.add('has-swap');
    });
  }

  /* ------------------------------------------------------------- tilt cards
     A few degrees of pointer-tracked tilt on the bordered cards. Pointer only,
     so touch devices never get a stuck transform. */
  function tiltCards(root) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('.slc-cg__card, .sl-card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateX(' + (-y * 3).toFixed(2) + 'deg) rotateY(' + (x * 3).toFixed(2) + 'deg) translateY(-3px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
